<template>
  <div class="warning-form">
    {{ msgFirstPart+msgReasonPart }}
  </div>
  <div class="form-buttons">
    <ButtonCustomized label="Ok" @click="onOk" />
  </div>
</template>

<script lang="ts" setup>import { computed } from 'vue';
import ButtonCustomized from "@/components/form-fields/ButtonCustomized.vue";

const emit = defineEmits(['ok']);
export interface Props {
  itemId?: string | number;
  itemsIds?: string[] | number[];
  isPermissionWarning?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  isPermissionWarning: false
});

const isSingleItem = computed(() => {     // false: means multiple items
  if(props.itemId || props.itemsIds.length === 1) {
    return true;
  } else if(props.itemsIds) {
    return false;
  }
});

const msgFirstPart = computed(() => {
  if (isSingleItem.value) {
    return "You are unable to copy this item because ";
  } else {
    return `You are unable to copy all of these items (${props.itemsIds.length} selected) because `;
  }
});

const msgReasonPart = computed(() => {
  if(props.isPermissionWarning) {
    if (isSingleItem.value) {
      return "you don't have permission to copy it.";
    } else {
      return "you don't have permission to copy all of them.";
    }
  }
  else {
    if (isSingleItem.value) {
      return "it is not a slide.";
    } else {
      return "not all of them are slides.";
    }
  }
});

function onOk() {
  emit('ok');
}
</script>

<style lang="scss" scoped>
.warning-form {
  display: flex;
  flex-direction: column;
  max-width: 30rem;
}

.form-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1rem;
}
</style>